import { render, staticRenderFns } from "./DatePickerOld.vue?vue&type=template&id=8f38711c&scoped=true"
import script from "./DatePickerOld.vue?vue&type=script&lang=js"
export * from "./DatePickerOld.vue?vue&type=script&lang=js"
import style0 from "./DatePickerOld.vue?vue&type=style&index=0&id=8f38711c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f38711c",
  null
  
)

export default component.exports